import enContent from './translations/content/defaultLanguage.json';
import arContent from './translations/content/ar.json';
import ruContent from './translations/content/ru-RU.json';
import frContent from './translations/content/fr-FR.json';
import itContent from './translations/content/it-IT.json';
import etContent from './translations/content/et-EE.json';
import esContent from './translations/content/es-ES.json';
import uaContent from './translations/content/uk-UA.json';
import deContent from './translations/content/de-DE.json';
import ltContent from './translations/content/lt-LT.json';

import enRoutes from './translations/routes/defaultLanguage.json';
import arRoutes from './translations/routes/ar.json';
import ruRoutes from './translations/routes/ru-RU.json';
import frRoutes from './translations/routes/fr-FR.json';
import itRoutes from './translations/routes/it-IT.json';
import etRoutes from './translations/routes/et-EE.json';
import esRoutes from './translations/routes/es-ES.json';
import uaRoutes from './translations/routes/uk-UA.json';
import deRoutes from './translations/routes/de-DE.json';
import ltRoutes from './translations/routes/lt-LT.json';
import koRoutes from './translations/routes/ko-KR.json';
import zhRoutes from './translations/routes/zh-CN.json';
import nlRoutes from './translations/routes/nl-NL.json';
import ptptRoutes from './translations/routes/pt-PT.json';
import ptbrRoutes from './translations/routes/pt-BR.json';
import plRoutes from './translations/routes/pl-PL.json';
import elRoutes from './translations/routes/el-GR.json';
import lvRoutes from './translations/routes/lv-LV.json';

import enFaqRoutes from './translations/faqRoutes/defaultLanguage.json';
import arFaqRoutes from './translations/faqRoutes/ar.json';
import ruFaqRoutes from './translations/faqRoutes/ru-RU.json';
import frFaqRoutes from './translations/faqRoutes/fr-FR.json';
import itFaqRoutes from './translations/faqRoutes/it-IT.json';
import etFaqRoutes from './translations/faqRoutes/et-EE.json';
import esFaqRoutes from './translations/faqRoutes/es-ES.json';
import uaFaqRoutes from './translations/faqRoutes/uk-UA.json';
import deFaqRoutes from './translations/faqRoutes/de-DE.json';
import ltFaqRoutes from './translations/faqRoutes/lt-LT.json';

import enPolicyRoutes from './translations/policyRoutes/defaultLanguage.json';
import arPolicyRoutes from './translations/policyRoutes/ar.json';
import ruPolicyRoutes from './translations/policyRoutes/ru-RU.json';
import frPolicyRoutes from './translations/policyRoutes/fr-FR.json';
import itPolicyRoutes from './translations/policyRoutes/it-IT.json';
import etPolicyRoutes from './translations/policyRoutes/et-EE.json';
import esPolicyRoutes from './translations/policyRoutes/es-ES.json';
import uaPolicyRoutes from './translations/policyRoutes/uk-UA.json';
import dePolicyRoutes from './translations/policyRoutes/de-DE.json';
import ltPolicyRoutes from './translations/policyRoutes/lt-LT.json';

import ltAllowedRoutes from './ltAllowedRoutes';

export enum LanguageContentType {
    CONTENT = 'content',
    ROUTES = 'routes',
    FAQROUTES = 'faqRoutes',
    POLICYROUTES = 'policyRoutes',
}

export interface Languages<T> {
	[key: string]: T;

    'en': T;
	'ar': T;
	'ru-RU': T;
	'fr-FR': T;
	'it-IT': T;
	'et-EE': T;
	'es-ES': T;
	'uk-UA': T;
	'de-DE': T;

    // Partially hidden
	'lt-LT': T;

	// Currently hidden (BNK-747)
	// 'ko-KR': T;
	// 'zh-CN': T;
	// 'nl-NL': T;
	// 'pt-PT': T;
	// 'pt-BR': T;
	// 'pl-PL': T;
	// 'el-GR': T;
	// 'lv-LV': T;
}

export interface LocaleMetadata {
	locale: string;
	title: string;
    minimalTemplate: boolean;
    allowlistedRoutes?: string[];
}

export type LocaleData = Record<string, string>;

export interface RoutesContextData {
    routes: Languages<LocaleData>;
    faqRoutes: Languages<LocaleData>;
    policyRoutes: Languages<LocaleData>;
}

export const languages: Languages<LocaleMetadata> = {
	'en': { locale: 'en', title: 'English', minimalTemplate: false },
	'ar': { locale: 'ar', title: 'اَلْعَرَبِيَّةُ', minimalTemplate: false },
	'ru-RU': { locale: 'ru-RU', title: 'Русский', minimalTemplate: false},
	'fr-FR': { locale: 'fr-FR', title: 'Français', minimalTemplate: false },
	'it-IT': { locale: 'it-IT', title: 'Italiano', minimalTemplate: false },
	'et-EE': { locale: 'et-EE', title: 'Eesti', minimalTemplate: false },
	'es-ES': { locale: 'es-ES', title: 'Español', minimalTemplate: false },
	'uk-UA': { locale: 'uk-UA', title: 'Українська', minimalTemplate: false },
	'de-DE': { locale: 'de-DE', title: 'Deutsch', minimalTemplate: false },

	// LT partially removed: BNK-692, BNK-695
	'lt-LT': { locale: 'lt-LT', title: 'Lietuvių', minimalTemplate: true, allowlistedRoutes: ltAllowedRoutes },

	// Currently hidden: BNK-747
	// 'ko-KR': { locale: 'ko-KR', title: '한국어' },
	// 'zh-CN': { locale: 'zh-CN', title: '简体中文' },
	// 'nl-NL': { locale: 'nl-NL', title: 'Nederlands' },
	// 'pt-PT': { locale: 'pt-PT', title: 'Português (PT)' },
	// 'pt-BR': { locale: 'pt-BR', title: 'Português (BR)' },
	// 'pl-PL': { locale: 'pl-PL', title: 'Polski' },
	// 'el-GR': { locale: 'el-GR', title: 'Ελληνικά' },
	// 'lv-LV': { locale: 'lv-LV', title: 'Latviešu' },
};

export const locales: string[] = Object.values(languages).map((metadata) => metadata.locale);

export const content: Languages<LocaleData> & { defaultLanguage: LocaleData } = {
	'en': enContent,
	'ar': arContent,
	'ru-RU': ruContent,
	'fr-FR': frContent,
	'it-IT': itContent,
	'et-EE': etContent,
	'es-ES': esContent,
	'uk-UA': uaContent,
	'de-DE': deContent,
	'lt-LT': ltContent,
	// add this line to prevent circular references
	defaultLanguage: { ...enContent },
};


export const routes: Languages<LocaleData> & { defaultLanguage: LocaleData } = {
	'en': enRoutes,
	'ar': arRoutes,
	'ru-RU': ruRoutes,
	'fr-FR': frRoutes,
	'it-IT': itRoutes,
	'et-EE': etRoutes,
	'es-ES': esRoutes,
	'uk-UA': uaRoutes,
	'de-DE': deRoutes,
    'lt-LT': ltRoutes,

    // Hidden language routes, used for creating redirects
	'ko-KR': koRoutes,
	'zh-CN': zhRoutes,
	'nl-NL': nlRoutes,
	'pt-PT': ptptRoutes,
	'pt-BR': ptbrRoutes,
	'pl-PL': plRoutes,
	'el-GR': elRoutes,
	'lv-LV': lvRoutes,
	// add this line to prevent circular references
	defaultLanguage: { ...enRoutes },
};


export const faqRoutes: Languages<LocaleData> & { defaultLanguage: LocaleData } = {
	'en': enFaqRoutes,
	'ar': arFaqRoutes,
	'ru-RU': ruFaqRoutes,
	'fr-FR': frFaqRoutes,
	'it-IT': itFaqRoutes,
	'et-EE': etFaqRoutes,
	'es-ES': esFaqRoutes,
	'uk-UA': uaFaqRoutes,
	'de-DE': deFaqRoutes,
	'lt-LT': ltFaqRoutes,
	// add this line to prevent circular references
	defaultLanguage: { ...enFaqRoutes },
};



export const policyRoutes: Languages<LocaleData> & { defaultLanguage: LocaleData } = {
	'en': enPolicyRoutes,
	'ar': arPolicyRoutes,
	'ru-RU': ruPolicyRoutes,
	'fr-FR': frPolicyRoutes,
	'it-IT': itPolicyRoutes,
	'et-EE': etPolicyRoutes,
	'es-ES': esPolicyRoutes,
	'uk-UA': uaPolicyRoutes,
	'de-DE': dePolicyRoutes,
	'lt-LT': ltPolicyRoutes,
	// add this line to prevent circular references
	defaultLanguage: { ...enPolicyRoutes },
};

